import { useState } from 'react';
import HeaderQuoteAi from './headerQuoteAi';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { useNavigate } from 'react-router-dom';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

const FullWorkBookPage = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [selectedState, setSelectedState] = useState('');
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [acordForm, setAcordForm] = useState('');

  const states = ['Select State', 'California', 'Texas', 'New York'];
  const businessLines = [
    {
      id: 1,
      img: '/assets/quoteAi/images/comensation.svg',
      label: 'Worker Compensation',
      color: 'bg-blue',
    },
    {
      id: 2,
      img: '/assets/quoteAi/images/liability.svg',
      label: 'General Liability',
      color: 'bg-lightblue',
    },
    {
      id: 3,
      img: '/assets/quoteAi/images/auto.svg',
      label: 'Auto',
      color: 'bg-yellow',
    },
    {
      id: 4,
      img: '/assets/quoteAi/images/property.svg',
      label: 'Property',
      color: 'bg-purple',
    },
    {
      id: 5,
      img: '/assets/quoteAi/images/package.svg',
      label: 'Package',
      color: 'bg-green',
    },
    {
      id: 6,
      img: '/assets/quoteAi/images/other.svg',
      label: 'Other',
      color: 'bg-lightgreen',
    },
  ];

  const [rowData] = useState([
    {
      ref: 'Q000001245',
      insuredName: 'AL Church Methodist',
      agentName: 'John Doe',
      agencyName: 'Doe Insurance',
      lob: 'WC',

      effectiveDate: '03/23/2024',
    },
    // repeat or map your data here
  ]);

  const [columnDefs] = useState([
    {
      headerName: '',
      field: 'expand',
      width: 50,
      pinned: 'left',
      autoHeight: true,
      cellRenderer: () => <i className="bi bi-plus-lg"></i>,
    },
    { headerName: 'Ref', field: 'ref', width: 200, autoHeight: true },
    { headerName: 'Insured Name', field: 'insuredName', width: 250, autoHeight: true },
    { headerName: 'Agent Name', field: 'agentName', width: 250, autoHeight: true },
    { headerName: 'Agency Name', field: 'agencyName', width: 250, autoHeight: true },
    { headerName: 'LOB', field: 'lob', width: 80, autoHeight: true },
    { headerName: 'Effective Date', field: 'effectiveDate', width: 150, autoHeight: true },
    {
      headerName: 'Alfred Alerts',
      field: 'alerts',
      width: 240,
      cellRenderer: () => {
        return (
          <div
            style={{
              display: 'flex',
              gap: '12px',
              justifyContent: 'center',
              alignItems: 'center',
              background: '#e5e5e5',
              padding: '6px',
              borderRadius: '6px',
            }}
          >
            {/* Magnifying Glass */}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="gray">
              <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zM10 14a4 4 0 110-8 4 4 0 010 8z" />
            </svg>

            {/* Spark/Star */}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="gray">
              <path d="M12 2L13.09 8.26L19 8.27L14 12.14L15.18 18L12 14.77L8.82 18L10 12.14L5 8.27L10.91 8.26L12 2Z" />
            </svg>

            {/* Wind */}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="gray">
              <path d="M4 12h13a3 3 0 100-6 3 3 0 00-3 3H4a1 1 0 000 2zm0 4h10a2 2 0 110 4 2 2 0 01-2-2H4a1 1 0 010-2zm0-8h8a1 1 0 000-2H4a1 1 0 000 2z" />
            </svg>

            {/* Lightning */}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="gray">
              <path d="M7 2v13h3v7l7-12h-4l4-8z" />
            </svg>

            {/* Money Bag */}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="gray">
              <path d="M12 1C10.9 1 10 1.9 10 3v1H8v2h8V4h-2V3c0-1.1-.9-2-2-2zM6 8c-1.1 0-2 .9-2 2v2c0 4.4 3.6 8 8 8s8-3.6 8-8v-2c0-1.1-.9-2-2-2H6z" />
            </svg>

            {/* Muscle Dollar */}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="gray">
              <path d="M18 2h-3v2h3v3h2V4c0-1.1-.9-2-2-2zm-1.5 13.5c-1.25 0-2.45-.38-3.5-1.02v1.77l-2.5 2.5L5 13V7.5C5 6.12 6.12 5 7.5 5S10 6.12 10 7.5V9h1V7.5C11 5.57 9.43 4 7.5 4S4 5.57 4 7.5V13c0 .53.21 1.04.59 1.41l6 6c.78.78 2.05.78 2.83 0l2.5-2.5V17c-.5.31-1.05.5-1.66.5z" />
            </svg>
          </div>
        );
      },
    },

    {
      headerName: '',
      field: 'actions',
      width: 50,
      pinned: 'right',
      cellRenderer: () => (
        <div className="dropdown threeDotsOption">
          <i
            className="bi bi-three-dots-vertical"
            role="button"
            id="dropdownMenuButton"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          ></i>
          <ul
            className="dropdown-menu dropdown-menu-end custom-shadow"
            aria-labelledby="dropdownMenuButton"
          >
            <li>
              <button
                className="dropdown-item d-flex align-items-center border-bottom icon-hover"
                onClick={() => (window.location.href = '/quoteAI/insuredInformationPage')}
              >
                <i className="bi bi-pencil me-2"></i>Edit
              </button>
            </li>
            <li>
              <button className="dropdown-item d-flex align-items-center border-bottom icon-hover">
                <i className="bi bi-trash me-2"></i>Delete
              </button>
            </li>
            <li>
              <button
                className="dropdown-item d-flex align-items-center icon-hover"
                onClick={() => (window.location.href = '/quoteAI/insuredInformationViewPage')}
              >
                <i className="bi bi-eye me-2"></i>View
              </button>
            </li>
          </ul>
        </div>
      ),
      width: 100,
    },
  ]);
  const [searchValue, setSearchValue] = useState('');

  const handleStartQuote = () => {
    if (acordForm === 'no') {
      navigate('/quoteAI/insuredInformationPage'); // Navigate when "No" is selected
    } else {
      // Handle the "Yes" case or show an error if needed
    }
  };

  const onSearch = () => {
    if (searchValue.trim() !== '') {
      // do your search logic here
      console.log('Searching for:', searchValue);
    }
  };

  const clearSearch = () => {
    setSearchValue('');
  };

  return (
    <>
      <div id="quoteAi">
        <HeaderQuoteAi />

        <div className="fullworkbook_dashboard">
          <div className="main">
            <div className="pageformBloack">
              <div className=" container-fluid ">
                <div className="whiteBoxCont mb-3">
                  <div className="workbookTopbar">
                    <div className="search-filter-bar quote_buttongroup">
                      <div id="workbook_search">
                        <div className="search-container">
                          <input
                            className="form-control"
                            id="filter-text-box"
                            type="text"
                            placeholder="Search..."
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' && searchValue.trim() !== '') {
                                onSearch();
                              }
                            }}
                          />

                          {searchValue && (
                            <span className="clear-btn" onClick={clearSearch}>
                              &times;
                            </span>
                          )}

                          <button className="contactsearch" type="button" onClick={onSearch}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <circle cx="11" cy="11" r="8"></circle>
                              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                            </svg>
                          </button>
                        </div>
                      </div>

                      <Button variant="outline-next" size="sm" className="button-space">
                        Advanced Filter
                      </Button>
                      <Button variant="outline-next" size="sm" className="button-space">
                        Clear Filter
                      </Button>
                    </div>

                    <div className="quote_buttongroup">
                      <Button
                        variant="primary-save"
                        size="sm"
                        className=" button-icon"
                        onClick={() => setShow(true)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 5v14M5 12h14"
                            className="add_Svg"
                            stroke="#fff"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                        </svg>
                        Quote
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="whiteBoxCont">
                  <div
                    className="ag-theme-balham quote-grid-style"
                    style={{
                      width: '100%',
                      height: 'calc(100vh - 196px)',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      overflow: 'hidden',
                    }}
                  >
                    <AgGridReact
                      rowData={rowData}
                      columnDefs={columnDefs}
                      pagination={true}
                      paginationPageSize={5}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          show={show}
          onHide={() => setShow(false)}
          className="quoteai_popup"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton className="title-header">
            <div>
              <Modal.Title as="h3">Create New Quote</Modal.Title>
              <p className="subtitle d-block">
                Select the line of business and primary state to start a new quote.
              </p>
            </div>
          </Modal.Header>
          <Modal.Body>
            {/* Step 1: Line Of Business */}
            <h4 className="step-title"> Line Of Business</h4>
            <Row>
              {businessLines.map((item) => (
                <Col
                  key={item.id}
                  md={2}
                  sm={12}
                  xs={12}
                  className="mb-3 d-flex justify-content-center"
                >
                  <div
                    className={`business-card ${item.color} ${selectedBusiness === item.id ? 'selected' : ''}`}
                    onClick={() => setSelectedBusiness(item.id)}
                    style={{ backgroundColor: item.bgColor }}
                  >
                    <div className="business-icon-container">
                      <img src={item.img} alt={item.label} className="popup-icon" />
                    </div>
                    <span className="business-label">{item.label}</span>
                  </div>
                </Col>
              ))}
            </Row>

            {/* Step 2: Primary State */}
            <h4 className="step-title d-flex align-items-center">
              Primary State
              <span
                className="ms-2"
                data-tooltip-id="my-tooltip"
                data-tooltip-content=" Select the primary state for the quote."
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="info-icon"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16Z" />
                  <path d="m8.93 6.588-.862.126-.088.45c.176-.098.364-.177.563-.236.198-.059.38-.088.545-.088.235 0 .428.057.578.17.15.114.225.267.225.46 0 .172-.05.311-.15.418-.099.106-.237.196-.412.27-.175.073-.404.166-.688.277-.284.112-.516.244-.695.396-.18.153-.305.333-.376.542-.072.208-.108.467-.108.777h1.002c0-.206.021-.376.063-.512.042-.136.106-.249.192-.34.085-.09.193-.162.324-.215.13-.053.287-.105.47-.157.234-.071.425-.156.572-.253.146-.098.26-.22.342-.366.081-.146.122-.321.122-.523 0-.329-.107-.576-.322-.74-.214-.164-.503-.246-.865-.246-.207 0-.397.025-.572.074Zm-1.862 4.312c0-.238.068-.417.204-.54.136-.122.312-.184.528-.184.216 0 .392.062.528.184.136.123.204.302.204.54 0 .237-.068.416-.204.538-.136.122-.312.183-.528.183-.216 0-.392-.061-.528-.183-.136-.122-.204-.301-.204-.538Z" />
                </svg>
              </span>
              <ReactTooltip id="my-tooltip" style={{ backgroundColor: '#2563eb' }}></ReactTooltip>
            </h4>

            <Form.Group className="state-select-group">
              <Form.Label>State</Form.Label>
              <Form.Select value={selectedState} onChange={(e) => setSelectedState(e.target.value)}>
                {states.map((state, index) => (
                  <option key={index} value={state}>
                    {state}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            {/* Step 3: ACORD Form */}
            <h4 className="step-title"> Do you have an ACORD form?</h4>
            <Form.Group>
              <div className="d-flex align-items-center">
                <Form.Check
                  type="radio"
                  label="Yes"
                  name="acordForm"
                  id="acordYes"
                  className="me-3"
                  checked={acordForm === 'yes'}
                  onChange={() => setAcordForm('yes')}
                />
                <Form.Check
                  type="radio"
                  label="No"
                  name="acordForm"
                  id="acordNo"
                  checked={acordForm === 'no'}
                  onChange={() => setAcordForm('no')} // Just update state, don't navigate immediately
                />
              </div>
            </Form.Group>

            {/* File Upload Section (Show only if "Yes" is checked) */}
            {acordForm === 'yes' && (
              <div className="file-upload-section mt-3">
                <Form.Group controlId="formFile">
                  <Form.Label className="step-title">Upload ACORD Form</Form.Label>
                  <Form.Control type="file" />
                </Form.Group>
              </div>
            )}
          </Modal.Body>

          {/* Footer */}
          <Modal.Footer className="quote_buttongroup">
            <Button variant="outline-cancel" onClick={() => setShow(false)}>
              Cancel
            </Button>
            <Button variant="primary-save" onClick={handleStartQuote}>
              Start Quote
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};
export default FullWorkBookPage;
